import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddShop = createAsyncThunk(
  "other/AddShop",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/shop/create/`, data)
    return response.data
  }
); 

export const UpdateShop = createAsyncThunk(
  "other/UpdateShop",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/shop/update/${data.id}/`, data)
    return response.data
  }
);

export const DeleteShop = createAsyncThunk(
  "other/DeleteShop",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/shop/delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

export const GetShops = createAsyncThunk(
  "other/GetShops",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/shop/list/`);
    return data
  }
);

